import Popover from 'react-bootstrap/Popover';

export const popoverActive = (
    <Popover
        id='popover-trigger-hover-focus'
        title='Location Active'
    >
        <ul>
            <li>Set the state of the location</li>
            <li>Inactive locations and all associated devices will not be visible to the client</li>
        </ul>
    </Popover>
);

export const popoverSuspended = (
    <Popover
        id='popover-trigger-hover-focus'
        title='Location Suspended'
    >
        <ul>
            <li>Set the suspended state of the location</li>
            <li>Suspended locations and all associated devices be visible to the client</li>
            <li>No data for a suspended location and it's associated device will be available to view by the client</li>
            <li>No alerts will be generated for devices</li>
        </ul>
    </Popover>
);

export const popoverOnboarded = (
  <Popover
    id='popover-trigger-hover-focus'
    title='Onboarding Status'
  >
      <ul>
          <li>Set the Onboarding status of the location</li>
          <li>Locations which are not onboarded will have the option to set an onboarding due date</li>
      </ul>
  </Popover>
);